<template>
  <v-radio-group
    ref="chosenFamily"
    v-model="chosenFamily"
    v-validate="chosenFamilyRules"
    class="v-input--radio-group_inner"
    :disabled="chosenOption !== 2"
    :error-messages="errors.collect('chosenFamilyRules')"
    :data-vv-as="$t('label.family_data')"
    data-vv-name="chosenFamilyRules"
    @change="emitChanges()"
  >
    <v-layout
      class=""
      wrap
    >
      <v-flex
        v-if="!previousEdition"
        md6
      >
        <EntranceFamilyItem
          :value="-1"
          :marked="false"
          :family="currentFamily"
        />
      </v-flex>
      <v-flex md6>
        <EntranceFamilyItem
          v-for="(family, index) in formattedSimilarFamilies"
          :key="index"
          :value="index"
          :family="family"
        >
          <template #indicator>
            <SimilarIndicator
              v-if="similarFamilies?.[index]?.similarity"
              :value="similarFamilies?.[index]?.similarity || 0"
            />
            <p
              v-if="previousEdition && family.edition"
              class="f-14 mb-0"
            >
              {{ $t('label.edition') }}: {{ family.edition }}
            </p>
          </template>
          <template
            v-if="!previousEdition"
            #createdBy
          >
            <div
              v-if="family.creator"
              class="family-item__header mt-0 mb-2"
            >
              <p class="mb-0">
                {{ $t('alikes_families.submitted_by') }}
              </p>
              <p class="mb-0">
                {{ family.creator.full_name }}
              </p>
              <p class="mb-0 font-weight-regular">
                {{ family.creator.email }}
              </p>
              <p
                v-if="family.creator.phone"
                class="mb-0 font-weight-regular"
              >
                {{ family.creator.phone | phone }}
              </p>
            </div>
          </template>
        </EntranceFamilyItem>
      </v-flex>
    </v-layout>
    <div
      v-if="cannotOverwriteFamily"
      class="f-14 fw-600"
    >
      {{ $t('message.edit_single_family_data') }}
    </div>
  </v-radio-group>
</template>

<script>
import EntranceFamilyItem from '@/components/widgets/addFamily/familySimilar/EntranceFamilyItem';
import SimilarIndicator from '@/components/widgets/addFamily/familySimilar/SimilarIndicator';
import validationRules from '@/constants/validationRules';
import overwriteSimilarFamilies from '@/mixins/overwriteSimilarFamilies';

export default {
    name: 'SimilarActionsChosenFamily',
    components: { EntranceFamilyItem, SimilarIndicator },
    mixins: [overwriteSimilarFamilies],
    inject: ['$validator'],
    props: {
        chosenOption: {
            required: true,
            validator: (v) => typeof v === 'number' || v === null
        },
        previousEdition: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        validationRules,
        chosenFamily: null
    }),
    computed: {
        chosenFamilyRules () {
            return this.chosenOption === 2 ? 'required' : '';
        },
        currentFamily () {
            return this.$store.getters['familyData/getCurrentFamily'];
        }
    },
    watch: {
        similarFamilies: {
            handler (val) {
                this.chosenFamily = null;
            }
        }
    },
    methods: {
        emitChanges () {
            this.$emit('change', this.chosenFamily);
        }
    }
};
</script>

<style scoped></style>
